import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PATH } from '../../../constants';

import LinkMore from '../LinkMore/LinkMore';
import Loader from '../Loader/Loader';

const LinksBoxesWithName = ({ links, isFetching = false }) => {
    const { t } = useTranslation();

    if (isFetching || !links) {
        return null;
    }

    return links.map((link) => {
        if (!link?.entries) {
            return null;
        }

        const entriesLinks = link?.entries?.slice(0, 3)?.map((entry) => (
            <li key={entry.id} className="links-box__item">
                <Link
                    className="link"
                    title={entry.name}
                    to={`${PATH.helpAndSupport}/${link.id}/${entry.id}`}
                >
                    {entry.name}
                </Link>
            </li>
        ));

        return (
            <div className="links-box links-box--with-entries" key={link.id} data-nr="categories-boxes">
                <h2 className="links-box__name">{link.name}</h2>
                {isFetching && <Loader spinner />}
                {!link?.entries?.length > 0 ? (
                    <p>{t('ui.linksBoxesWithName.empty')}</p>
                ) : (
                    <>
                        <ul>{entriesLinks}</ul>
                        <LinkMore
                            additionalClassNames="links-box__more"
                            contentId={link.id}
                            anchor={t('ui.shared.categoryLinkText')}
                            name={link.name}
                        />
                    </>
                )}
            </div>
        );
    });
};

export default LinksBoxesWithName;
